const html2canvas = require('html2canvas');

export default class SnapshotService {
    proxyUrl: string;

    constructor(proxyUrl?: string) {
        this.proxyUrl = proxyUrl;
    }

    // from: http://stackoverflow.com/a/7372816/2020766
    getBinaryBase64(url): Promise<string> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.onload = () => {
                resolve(this.base64Encode(xhr.responseText));
            };
            xhr.onabort = xhr.onerror = () => {
                reject();
            };

            xhr.open('GET', url, true);
            xhr.overrideMimeType('text/plain; charset=x-user-defined');
            xhr.send();
        });

        /*
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.send(null);
        return new Promise((resolve, reject) => {
            xhr.onload = (e: any) => {
                resolve(this.base64ArrayBuffer(e.currentTarget.response));
            };
        });
        */
    }

    base64Encode(str) {
        const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        let out = '',
            i = 0,
            len = str.length,
            c1,
            c2,
            c3;
        while (i < len) {
            c1 = str.charCodeAt(i++) & 0xff;
            if (i == len) {
                out += CHARS.charAt(c1 >> 2);
                out += CHARS.charAt((c1 & 0x3) << 4);
                out += '==';
                break;
            }
            c2 = str.charCodeAt(i++);
            if (i == len) {
                out += CHARS.charAt(c1 >> 2);
                out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
                out += CHARS.charAt((c2 & 0xf) << 2);
                out += '=';
                break;
            }
            c3 = str.charCodeAt(i++);
            out += CHARS.charAt(c1 >> 2);
            out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
            out += CHARS.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
            out += CHARS.charAt(c3 & 0x3f);
        }
        return out;
    }

    base64ArrayBuffer(arrayBuffer) {
        let base64 = '';
        const encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

        const bytes = new Uint8Array(arrayBuffer);
        const byteLength = bytes.byteLength;
        const byteRemainder = byteLength % 3;
        const mainLength = byteLength - byteRemainder;

        let a, b, c, d;
        let chunk;

        // Main loop deals with bytes in chunks of 3
        let i;
        for (i = 0; i < mainLength; i = i + 3) {
            // Combine the three bytes into a single integer
            chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

            // Use bitmasks to extract 6-bit segments from the triplet
            a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
            b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
            c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
            d = chunk & 63; // 63       = 2^6 - 1

            // Convert the raw binary segments to the appropriate ASCII encoding
            base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
        }

        // Deal with the remaining bytes and padding
        if (byteRemainder == 1) {
            chunk = bytes[mainLength];

            a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

            // Set the 4 least significant bits to zero
            b = (chunk & 3) << 4; // 3   = 2^2 - 1

            base64 += encodings[a] + encodings[b] + '==';
        } else if (byteRemainder == 2) {
            chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

            a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
            b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

            // Set the 2 least significant bits to zero
            c = (chunk & 15) << 2; // 15    = 2^4 - 1

            base64 += encodings[a] + encodings[b] + encodings[c] + '=';
        }

        return base64;
    }

    getFonts(): CSSStyleDeclaration[] {
        let fonts = [],
            sheet: any = document.styleSheets,
            rule = null,
            i = sheet.length,
            j;
        while (0 <= --i) {
            rule = sheet[i].rules || sheet[i].cssRules || [];
            j = rule.length;
            while (0 <= --j) {
                if (rule[j].constructor.name === 'CSSFontFaceRule') {
                    // rule[j].slice(0, 10).toLowerCase() === '@font-face'
                    fonts.push(rule[j].style);
                }
            }
        }
        return fonts as CSSStyleDeclaration[];
    }

    applyFonts(
        element: HTMLElement | SVGSVGElement,
        fontList?: string[]
    ): Promise<HTMLElement | SVGSVGElement> {
        const fonts = this.getFonts();
        // console.log('fonts', fonts);

        const promises = fonts
            .filter(font => {
                if (fontList && fontList.indexOf(font.getPropertyValue('font-family')) === -1) {
                    return false;
                }

                const src = font.getPropertyValue('src');
                return !!src;
            })
            .map(font => {
                // console.log(font);

                const src = font.getPropertyValue('src');
                // console.log('src', src);

                const url = src.match(/\((.*?)\)/)[1].replace(/('|")/g, '');
                // console.log('url', url);

                return this.getBinaryBase64(url).then((encoded: string) => {
                    // let encoded = Base64.encode(response.data);
                    // console.log(url, encoded);

                    // from: http://graphicdesign.stackexchange.com/a/5167
                    const parts = [];
                    parts.push('@font-face {');
                    parts.push('font-family: "' + font.getPropertyValue('font-family') + '";');
                    parts.push('src: url("data:application/x-font-ttf;base64,' + encoded + '");');
                    if (font.getPropertyValue('font-weight')) {
                        parts.push('font-weight: ' + font.getPropertyValue('font-weight') + ';');
                    }
                    if (font.getPropertyValue('font-style')) {
                        parts.push('font-style: ' + font.getPropertyValue('font-style') + ';');
                    }
                    parts.push('}');

                    // console.log(parts.join('\n'));

                    return parts.join('\n\n');
                });
            });

        return Promise.all(promises).then(
            fontFaces => {
                // console.log(fontFaces);

                const defs = document.createElement('defs');
                defs.innerHTML = '<style type="text/css">' + fontFaces.join('\n') + '</style>';
                (element as HTMLElement).insertBefore(defs, element.firstChild);

                return element;
            },
            error => {
                console.log('Error loading fonts', error);
                return element;
            }
        );
    }

    convertToImage(
        svgElement: HTMLElement | SVGSVGElement
    ): Promise<HTMLElement | SVGSVGElement | void> {
        const svg = new XMLSerializer().serializeToString(svgElement);
        const imgsrc = 'data:image/svg+xml;utf8,' + svg;

        const img = new Image((svgElement as any).offsetWidth, (svgElement as any).offsetHeight);
        img.src = imgsrc;

        svgElement.parentNode.insertBefore(img, svgElement);
        svgElement.parentNode.removeChild(svgElement);
        return new Promise<HTMLElement | SVGSVGElement>(function(resolve, reject) {
            img.onload = () => {
                // window.location.href = imgsrc;
                resolve(svgElement);
            };
            img.onerror = () => {
                console.error('Error loading SVG image');
                reject();
            };
        });
    }

    isVisible(el: any) {
        const style = window.getComputedStyle(el);
        return (
            style.getPropertyValue('display') !== 'none' &&
            style.getPropertyValue('visibility') !== 'invisible' &&
            style.getPropertyValue('opacity') !== '0'
        );
    }

    // this is adapted (barely) from svg-crowbar
    // https://github.com/NYTimes/svg-crowbar/blob/gh-pages/svg-crowbar-2.js#L211-L250
    applyStylesheets(element: HTMLElement | SVGSVGElement): string[] {
        // use an empty svg to compute the browser applied stylesheets
        const emptySvg = window.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        window.document.body.appendChild(emptySvg);
        const emptySvgDeclarationComputed = getComputedStyle(emptySvg);
        emptySvg.parentNode.removeChild(emptySvg);

        const usedFonts: string[] = [];

        // traverse the element tree and explicitly set all stylesheet values
        // on an element. this is ripped from svg-crowbar
        const allElements = this.traverse(element);
        let i = allElements.length;
        while (i--) {
            this.explicitlySetStyle(allElements[i], emptySvgDeclarationComputed, usedFonts);
        }

        return usedFonts;
    }

    explicitlySetStyle(
        element: HTMLElement,
        emptySvgCSS: CSSStyleDeclaration,
        fontList?: string[]
    ) {
        const elementCSS = getComputedStyle(element);
        let i;
        let len;
        let key;
        let value;
        let computedStyleStr = '';

        for (i = 0, len = elementCSS.length; i < len; i++) {
            key = elementCSS[i];
            value = (elementCSS.getPropertyValue(key) || '') + '';
            if (key.indexOf('transition') !== -1) {
                continue;
            }

            const emptyVersion = (emptySvgCSS.getPropertyValue(key) || '') + '';
            if (value !== emptyVersion) {
                if (key === 'font-family' && fontList && fontList.indexOf(value) === -1) {
                    fontList.push(value);
                }
                computedStyleStr += key + ':' + value + ';';
            }
        }
        // console.log('style', computedStyleStr);
        element.setAttribute('style', computedStyleStr);
    }

    // traverse an svg and append all of the elements to the tree array. This
    // ignores some elements that can appear in <svg> elements but whose
    // children's styles should not be tweaked
    traverse(obj: HTMLElement | SVGSVGElement) {
        const tree = [];
        const ignoreElements = {
            script: undefined,
            defs: undefined,
        };
        tree.push(obj);
        visit(obj);
        function visit(node) {
            if (node && node.hasChildNodes() && !(node.nodeName.toLowerCase() in ignoreElements)) {
                let child = node.firstChild;
                while (child) {
                    if (child.nodeType === 1) {
                        tree.push(child);
                        visit(child);
                    }
                    child = child.nextSibling;
                }
            }
        }
        return tree;
    }

    getSnapShot(element: Node, matchWidth?: boolean): Promise<HTMLCanvasElement> {
        const cloneElement: HTMLElement = element.cloneNode(true) as HTMLElement;
        const wrapper = window.document.createElement('div');
        wrapper.appendChild(cloneElement);
        if (matchWidth) {
            wrapper.style.width = (element as any).offsetWidth + 'px';
        }

        wrapper.style.position = 'absolute';
        wrapper.style.zIndex = '-99999';
        document.body.insertBefore(wrapper, document.body.firstChild);

        Array.from(
            cloneElement.querySelectorAll(
                '.widget__select, .inline_edit .icon__container, .panel_placeholder, .layout_grid, .post_transition_prev, .post_transition_next'
            )
        ).forEach((unwantedElement: any) => {
            unwantedElement.parentElement.removeChild(unwantedElement);
        });

        const svgElements: SVGSVGElement[] = Array.from(
            cloneElement.getElementsByTagName('svg')
        ).filter(svg => {
            return this.isVisible(svg);
        });

        wrapper.style.opacity = '0';

        const promises: Promise<any>[] = svgElements.map((svgElement: SVGSVGElement) => {
            const fontList: string[] = this.applyStylesheets(svgElement);
            // return this.applyFonts(svgElement, fontList).then(() => {
            return this.convertToImage(svgElement);
            // });
        });

        return Promise.all(promises).then(
            (): Promise<HTMLCanvasElement> => {
                // cloneElement.style.visibility = 'visible';
                return html2canvas(cloneElement, {
                    allowTaint: false,
                    useCORS: !this.proxyUrl,
                    proxy: this.proxyUrl,
                }).then(
                    (canvas: HTMLCanvasElement) => {
                        document.body.removeChild(wrapper);
                        return canvas;
                    },
                    error => {
                        console.error('Error taking snapshot', error);
                        document.body.removeChild(wrapper);
                        return null;
                    }
                ) as Promise<HTMLCanvasElement>;
            }
        );
    }
}
